module.exports = __webpack_public_path__ + "static/media/ring.917a20be.svg";